import React, {useEffect, useState} from 'react';
import {Button, Col, Container, Row, Table} from 'react-bootstrap';

import {service as ActivityFeedSubscriptionService} from "../../../Services/ActivityFeedSubscriptionService";

import {Glyphicon} from "../../Common/GlyphIcon";
import {MutableList} from "../../Common/List/MutableList";

import {
    ArrayUtils,
    GuidUtils,
    ObjectUtils,
} from "../../../Utils";

import {useCheckAuth} from "../../../Hooks/RouteHooks";
import {useMakePageRequest} from "../../../Hooks/RequestHooks";

import {ContextNodeWithFullContextViewer} from "../../Common/ContextNodeWithFullContextViewer";

import {useContextIndependentPage} from "../../../Hooks/ContextBuilderHooks";
import {useClassNames} from "../../../Hooks/StyleHooks";

import {UserOrgContextNodeAutoSelect} from "../../Common/UserOrgContextNodeAutoSelect";
import {SubscriptionsPageRecord} from "./SubscriptionsPageRecord";
import {ActivityFeedFilterViewer} from "./ActivityFeedFilterViewer";
import {useListManagement} from "../../../Hooks/useListManagement";


export const UsersSubscriptionsPage = props => {
    useCheckAuth();
    useContextIndependentPage();

    const classNames = useClassNames('sb-users-subscriptions-page');
    const makePageRequest = useMakePageRequest();

    const [subscriptions, setSubscriptions] = useState([]);
    const [addSubscription, updateSubscription, removeSubscription] = useListManagement(subscriptions, setSubscriptions, 'activityFeedSubscriptionId');
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        makePageRequest(
            () => ActivityFeedSubscriptionService.GetActivityFeedSubscriptions(),
            (x) => {
                setSubscriptions(x.result);
                setEditMode(false);
            }
        );
    };

    const save = () => {
        makePageRequest(
            () => ActivityFeedSubscriptionService.UpdateActivityFeedSubscriptions(subscriptions),
            () => setEditMode(false)
        );
    };

    const updateContextNode = (oldValue, newValue) => {
        let clone = ObjectUtils.Clone(subscriptions);
        
        setSubscriptions(subscriptions.map((x) => {
            // intentionally use == to compare, since contextNodeId can be null
            // and oldValue can be undefined
            console.log('Updating context node:', x.contextNodeId, oldValue, newValue);
            if(String(x.contextNodeId) == String(oldValue)) {
                return {
                    // what to do if they change null -> something and they already have a null one?
                    ...x,
                    contextNodeId: newValue
                };
            }
            return x;
        }));
    };

    const addContextNode = () => {
        const newItem = {
            contextNodeId: undefined,
            _tempId: GuidUtils.Generate(),
        }
        
        addSubscription(newItem);
    };

    let groups = ArrayUtils.GroupBy(
        [...subscriptions],
        (x) => x?.contextNodeId,
        (a, b) =>
            (a.key === null) - (b.key === null) || // consistently sort nulls
            (a.key - b.key)
    )
    
    console.log('Grouped subscriptions:', groups);

    return <Container className={classNames}>
        <Row>
            <Col xs={12} md={12}>
                <h2 className="atomic-sectionheader">
                    <div className="float-right btn-edit">
                        {
                            editMode ?
                                [
                                    <Button
                                        variant="save"
                                        key={1}
                                        onClick={() => save()}
                                    >
                                        Save
                                    </Button>,
                                    <Button
                                        variant="cancel"
                                        key={2}
                                        onClick={() => loadData()}
                                    >
                                        Cancel
                                    </Button>
                                ]:
                                <Button
                                    className="link btn-link"
                                    key={1}
                                    onClick={() => setEditMode(true)}
                                >
                                    <Glyphicon glyph="pencil">Edit</Glyphicon>
                                </Button>
                        }
                    </div>
                    Subscriptions
                </h2>
                <Table className={`sb-users-subscriptions-table ${editMode ? 'editing' : ''}`} striped bordered size="sm" hover>
                    <tbody>
                    {
                        groups.map((group) =>
                            editMode ?
                                <tr key={group.key}>
                                    <td>
                                        <UserOrgContextNodeAutoSelect
                                            Value={group.key}
                                            OnUpdate={(newContextNodeId) => updateContextNode(group.key, newContextNodeId)}
                                            placeholder={group.key === null ? "All Contexts" : "Select Context"}
                                            allowNull={true}
                                        />
                                    </td>
                                    <td>
                                        <MutableList
                                            Data={group.value}
                                            Editable={true}
                                            Type={SubscriptionsPageRecord}
                                            AdditionalTypeProps={{}}
                                            AddItem={() => addSubscription({contextNodeId: group.key})}
                                            UpdateItem={updateSubscription}
                                            RemoveItem={removeSubscription}
                                            GetItemKey={(x) => x.activityFeedSubscriptionId ?? x._tempId}
                                            sortKey="contextNodeId"
                                        />
                                    </td>
                                </tr>:
                                <tr key={group.key}>
                                    <td>
                                        <ContextNodeWithFullContextViewer contextNodeId={group.key} />
                                    </td>
                                    <td>
                                        <div className="sb-activity-feed-filter-list">
                                            {
                                                group.value.map((y) =>
                                                    <ActivityFeedFilterViewer
                                                        key={y.activityFeedFilterId}
                                                        ActivityFeedFilterId={y.activityFeedFilterId}
                                                    />
                                                )
                                            }
                                        </div>
                                    </td>
                                </tr>
                        )
                    }
                    </tbody>
                </Table>
            </Col>
            <Col xs={12} md={12}>
                {
                    editMode ?
                        <a className="float-right" onClick={addContextNode}>
                            <Glyphicon glyph="plus-sign">Add Program/Project</Glyphicon>
                        </a>:
                        null
                }
            </Col>
        </Row>
    </Container>;
};


